import React, {useContext} from 'react';
import classnames from 'classnames';

import styles from './notification-alert.module.scss';
import {RaiseEventListenerContext} from './raise-event-listener-context';

// Add a red dot to an icon to indicate there are unread notifications
interface Props {
  children: React.ReactNode;
  color?: 'white' | 'blue'; // border color of the red dot
  show?: boolean;
}

const NotificationAlert = ({children, color = 'white', show}: Props) => {
  const {notificationCenterAlert} = useContext(RaiseEventListenerContext);

  return show && notificationCenterAlert ? (
    <div
      className={classnames('shared-notification-alert notification', {
        [styles.blue]: color === 'blue',
      })}
    >
      {children}
    </div>
  ) : (
    children
  );
};

export default NotificationAlert;
